<template>
  <v-card>
    <v-layout>
      <v-app-bar title="ONEPLAN Админка"></v-app-bar>

      <Navigation />

      <v-main style="min-height: calc(100vh - 100px)">
        <v-container fluid>
          <v-card>
            <v-card-title>{{ title }}</v-card-title>
            <v-card-text>
              <SubcategoryEdit />
            </v-card-text>
          </v-card>
        </v-container>
      </v-main>
    </v-layout>
  </v-card>
</template>
<script>
import Navigation from "@/components/Navigation";
import SubcategoryEdit from "@/components/Subcategories/SubcategoryEdit.vue";
export default {
  components: {
    Navigation,
    SubcategoryEdit
  },
  computed: {
    title: {
      get(){
        return this.$route.params.id > 0 ? "Редактирование категории" : "Создание категории";
      }
    }
  },
};
</script>
